function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */

/**
 * React Components
 */
import AsyncSelectMulti from '@engine/components/containers/async-select-multi';
import ApplePayMerchantOnboardingPanel from '@engine/components/presentational/apple-pay-merchant-registration/onboarding-panel';
import AmountFieldContainer from '@engine/components/containers/vt/amount-field-container';
import BlacklistNewForm from '@engine/components/containers/blacklist-new-form';
import CopyContainer from '@engine/components/presentational/copy-container';
import CustomerEmailContainer from '@engine/components/containers/pay-by-link/customer-email-container';
import CustomExportModal from '@engine/components/containers/custom-export/modal';
import CustomizableColumnsForm from '@engine/components/containers/customizable-columns-form';
import DecryptFieldContainer from '@engine/components/containers/decrypt-field-container';
import DetailsContainer from '@engine/components/containers/vt/details-container';
import EmailConfigurationsContainer from '@engine/components/containers/email-configurations/container';
import MerchantCredentials from '@engine/components/containers/merchant-credentials';
import MerchantWpfThemes from '@engine/components/containers/merchant-wpf-themes';
import PasswordField from '@engine/components/presentational/base/password-field';
import RandomPasswordGenerator from '@engine/components/presentational/base/random-password-generator';
import ReactOnRails from 'react-on-rails';
import ReactTooltip from 'react-tooltip';
import RiskFilterSettingsEditForm from '@engine/components/containers/risk-filter-settings-edit-form';
import RiskFiltersConfigurationWizard from '@engine/components/containers/risk-filters-configuration-wizard';
import PanelLog from '@engine/components/containers/panel-log';
import PayPalMerchantRegistrationModal from '@engine/components/containers/pay-pal-merchant-registration/modal';
import SessionTimer from '@engine/components/sessionTimer';
import ShowWpfFields from '@engine/components/containers/show_wpf_fields';
import WpfTopLevelBankCodes from '@engine/components/containers/wpf_top_level_bank_codes';
import TerminalSelectContainer from '@engine/components/containers/vt/terminal-select-container';
import TransactionNoteReview from '@engine/components/containers/transaction-note-review';
import VolumesForSelection from '@engine/components/containers/volumes-for-selection';
import withAsyncReducer from '@engine/components/withAsyncReducer';
import withProvider from '@engine/components/withProvider';
import FileUpload from '@engine/components/containers/file-upload/file-upload';
import UserEnabled from '@engine/components/containers/user-enabled';
import UserLoginEnabled from '@engine/components/containers/user-login-enabled';
import FlashMessage from '@engine/components/containers/flash-message';
import ReceiptDownloadBtn from '@engine/components/containers/receipt/receipt-download-btn';
import WpfCustomThemeV2 from '@engine/components/containers/v2/wpf-custom-theme/wpf-custom-theme';
import MerchantRemindersConfig from '@engine/components/containers/merchant-reminders-config';
import RecurringType from '@engine/components/containers/vt/recurring-type';
import ContractFormFeaturesContainer from '@engine/components/containers/contract-form/contract-form-features-container';
import ContractMerchantCodeSelectContainer from '@engine/components/containers/contract-form/contract-merchant-code-select-container';
/**
 * List of the dynamic Reducers
 */

/* eslint sort-imports: ["off"] */

import asyncSelectMultiReducer from '@engine/reducers/async-select-multi.reducer';
import customExportFormReducer from '@engine/reducers/custom-export-form.reducer';
import customizableColumnsReducer from '@engine/reducers/customizable-columns.reducer';
import decryptField from '@engine/reducers/decrypt-field.reducer';
import mailersFormReducer from '@engine/reducers/email/form.reducer';
import transactionNoteReviewReducer from '@engine/reducers/transaction-note-review.reducer';
import panelLogReducer from '@engine/reducers/panel-log.reducer';
import uploadFileReducer from '@engine/reducers/upload-file.reducer';
import userStatusReducer from '@engine/reducers/user-status.reducer';
var componentsWithAsyncReducer = {
  DecryptFieldContainer: withAsyncReducer(DecryptFieldContainer,
  /**
   * Extensions rule for the DecryptFieldContainer dynamic reducer
   */
  function (props) {
    return [{
      key: "decrypt".concat(props.field),
      reducer: decryptField(props.field)
    }];
  }),
  TransactionNoteReview: withAsyncReducer(TransactionNoteReview,
  /**
   * Extensions rule for the TransactionNoteReview dynamic reducer
   */
  function (props) {
    return [{
      key: "transactionNoteReview-".concat(props.transactionNote.id),
      reducer: transactionNoteReviewReducer(props.transactionNote.id)
    }];
  }),
  UserEnabled: withAsyncReducer(UserEnabled,
  /**
   * Extensions rule for the UserEnabled dynamic reducer
   */
  function (props) {
    return [{
      key: "userStatus-".concat(props.userId),
      reducer: userStatusReducer(props.userId)
    }];
  }),
  UserLoginEnabled: withAsyncReducer(UserLoginEnabled,
  /**
   * Extensions rule for the UserLoginEnabled dynamic reducer
   */
  function (props) {
    return [{
      key: "userStatus-".concat(props.userId),
      reducer: userStatusReducer(props.userId)
    }];
  }),
  PanelLog: withAsyncReducer(PanelLog,
  /**
   * Extensions rule for the PanelLog dynamic reducer
   */
  function (props) {
    return [{
      key: "panelLog-".concat(props.logType),
      reducer: panelLogReducer(props.logType)
    }];
  }),
  EmailConfigurationsContainer: withAsyncReducer(EmailConfigurationsContainer, function (_props) {
    return [{
      key: 'templateForm',
      reducer: mailersFormReducer('template')
    }, {
      key: 'configurationForm',
      reducer: mailersFormReducer('configuration')
    }];
  }),
  AsyncSelectMulti: withAsyncReducer(AsyncSelectMulti,
  /**
   * Extensions rule for the AsyncSelectMulti dynamic reducer
   */
  function (props) {
    return [{
      key: "asyncSelectMulti-".concat(props.id),
      reducer: asyncSelectMultiReducer(props.id)
    }];
  }),
  CustomerEmailContainer: withAsyncReducer(CustomerEmailContainer,
  /**
   * Extensions rule for the AsyncSelectMulti dynamic reducer
   */
  function (props) {
    return [{
      key: "asyncSelectMulti-".concat(props.id),
      reducer: asyncSelectMultiReducer(props.id)
    }];
  }),
  CustomizableColumnsForm: withAsyncReducer(CustomizableColumnsForm,
  /**
   * Extensions rule for the customizable columns reducer
   */
  function (props) {
    return [{
      key: "columns-for-".concat(props.preference),
      reducer: customizableColumnsReducer(props.preference)
    }];
  }),
  CustomizedExportBtn: withAsyncReducer(CustomExportModal,
  /**
   * Extensions rule for the customizable columns reducer
   */
  function (props) {
    return [{
      key: "custom-export-".concat(props.preference),
      reducer: customExportFormReducer(props.preference)
    }, {
      key: "columns-for-".concat(props.preference),
      reducer: customizableColumnsReducer(props.preference)
    }];
  }),
  FileUpload: withAsyncReducer(FileUpload,
  /**
   * Extensions rule for the customizable columns reducer
   */
  function (props) {
    return [{
      key: "".concat(props.inputName, "-upload"),
      reducer: uploadFileReducer(props.inputName)
    }];
  }),
  TerminalSelectContainer: withAsyncReducer(TerminalSelectContainer,
  /**
   * Extensions rule for the AsyncSelectMulti dynamic reducer
   */
  function (props) {
    return [{
      key: "asyncSelectMulti-".concat(props.id),
      reducer: asyncSelectMultiReducer(props.id)
    }];
  })
};
/**
 * Register & Initialize React Engine Components
 */

function initialize(initializeReactApp) {
  /** Cache the CSRF Token */
  global.CSRF = ReactOnRails.authenticityToken();
  ReactOnRails.register(_objectSpread({
    ApplePayMerchantOnboardingPanel: withProvider(ApplePayMerchantOnboardingPanel),
    BlacklistNewForm: withProvider(BlacklistNewForm),
    CopyContainer: CopyContainer,
    PasswordField: PasswordField,
    ReceiptDownloadBtn: ReceiptDownloadBtn,
    MerchantRemindersConfig: withProvider(MerchantRemindersConfig),
    RandomPasswordGenerator: RandomPasswordGenerator,
    MerchantWpfThemes: withProvider(MerchantWpfThemes),
    RiskFiltersConfigurationWizard: withProvider(RiskFiltersConfigurationWizard),
    RiskFilterSettingsEditForm: withProvider(RiskFilterSettingsEditForm),
    PayPalMerchantRegistrationModal: withProvider(PayPalMerchantRegistrationModal),
    SessionTimerContainer: withProvider(SessionTimer),
    ShowWpfFields: withProvider(ShowWpfFields),
    WpfTopLevelBankCodes: withProvider(WpfTopLevelBankCodes),
    VolumesForSelection: withProvider(VolumesForSelection),
    FlashMessage: withProvider(FlashMessage),
    MerchantCredentials: withProvider(MerchantCredentials),
    DetailsContainer: withProvider(DetailsContainer),
    WpfCustomThemeV2: withProvider(WpfCustomThemeV2),
    AmountFieldContainer: withProvider(AmountFieldContainer),
    RecurringType: withProvider(RecurringType),
    ContractFormFeaturesContainer: withProvider(ContractFormFeaturesContainer),
    ContractMerchantCodeSelectContainer: withProvider(ContractMerchantCodeSelectContainer),
    ReactTooltip: ReactTooltip
  }, componentsWithAsyncReducer));
  /**
   * Application Components
   */

  if (typeof initializeReactApp === 'function') {
    initializeReactApp();
  }
}

var EngineReact = {
  initialize: initialize
};
export default EngineReact;